import { useMutation } from '@apollo/client';
import { useTranslation } from '@crehana/i18n';
import { useUITheme } from '@crehana/web';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';

import DeactivateRouteMutation from './graphql/DeactivateRoute.v4.b2b.graphql';
import type {
  DeactivateRoute,
  DeactivateRouteVariables,
} from './graphql/types/DeactivateRoute';

type UseDeleteRouteProps = {
  onComplete?: () => void;
};

const useDeactivateRoute = ({ onComplete }: UseDeleteRouteProps) => {
  const { t } = useTranslation();
  const { isDark } = useUITheme();
  const { openSnackbar } = useAdminDashboard();

  const [deactivateRoute, { loading }] = useMutation<
    DeactivateRoute,
    DeactivateRouteVariables
  >(DeactivateRouteMutation, {
    context: { clientName: 'v4.b2b' },
  });

  const onDeactivate = async ({
    teamId,
    isHidden,
  }: {
    teamId: number;
    isHidden: boolean;
  }) => {
    try {
      const response = await deactivateRoute({
        variables: {
          teamId,
          isHidden,
        },
      });
      if (response.data?.updateTeam?.success) {
        onComplete && onComplete();
      } else {
        openSnackbar({
          msg: t('TRACK_DETAIL_EDITED_NAME_ERROR'),
          type: 'alert',
          darkMode: isDark,
        });
      }
    } catch (err) {
      openSnackbar({
        msg: t('SNACKBAR_DEFAULT_ERROR'),
        type: 'alert',
        darkMode: isDark,
      });
    }
  };

  return {
    onDeactivate,
    loading,
  };
};

export default useDeactivateRoute;
